'use strict';

const _DefaultExceptionEventData = class _DefaultExceptionEventData {
  constructor(event) {
    this.event = event;
  }
  getType() {
    return this.getTitleException().type ?? _DefaultExceptionEventData.UNKNOWN_TYPE;
  }
  getValue() {
    return this.getTitleException().value ?? _DefaultExceptionEventData.UNKNOWN_VALUE;
  }
  getLevel() {
    return this.event.level ?? _DefaultExceptionEventData.UNKNOWN_LEVEL;
  }
  getFingerPrint() {
    return this.event.fingerprint ?? ["{{ default }}"];
  }
  getExtra() {
    return this.event.extra;
  }
  getTitleException() {
    const exceptions = this.event.exception?.values ?? [];
    return exceptions[exceptions.length - 1] ?? {};
  }
};
_DefaultExceptionEventData.UNKNOWN_TYPE = "Unknown Type";
_DefaultExceptionEventData.UNKNOWN_VALUE = "Unknown Value";
_DefaultExceptionEventData.UNKNOWN_LEVEL = "error";
let DefaultExceptionEventData = _DefaultExceptionEventData;

module.exports = DefaultExceptionEventData;
//# sourceMappingURL=DefaultEvent.cjs.map
